export default "__VITE_ASSET__CTwW3AyA__"